import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext.js';

export function AuthModal({
  isOpen,
  onClose,
}: {
  readonly isOpen: boolean;
  readonly onClose: () => void;
}): JSX.Element | null {
  const { login, register } = useAuth();
  const [tab, setTab] = useState<'login' | 'register'>('login');
  const [identity, setIdentity] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);

    try {
      if (tab === 'login') {
        const res = await login(identity, password);
        if (!res.ok) {
          setError(res.message ?? 'Usuário ou senha incorretos.');
          return;
        }
      } else {
        const res = await register(identity, email, password);
        if (!res.ok) {
          setError(res.message ?? 'Não foi possível criar a conta.');
          return;
        }
      }
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <div className="auth-tabs">
            <button
              type="button"
              className={`auth-tab ${tab === 'login' ? 'active' : ''}`}
              onClick={() => {
                setTab('login');
                setError(null);
              }}
            >
              Entrar
            </button>
            <button
              type="button"
              className={`auth-tab ${tab === 'register' ? 'active' : ''}`}
              onClick={() => {
                setTab('register');
                setError(null);
              }}
            >
              Criar Conta
            </button>
          </div>
          <button type="button" className="auth-modal-close" onClick={onClose} title="Fechar">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error-box">{error}</div>}

          <div className="auth-field">
            <label htmlFor="auth-identity">
              {tab === 'login' ? 'Usuário ou E-mail' : 'Nome de Usuário'}
            </label>
            <input
              id="auth-identity"
              type="text"
              value={identity}
              onChange={(e) => setIdentity(e.target.value)}
              placeholder={tab === 'login' ? 'ex: distortidus' : 'ex: guerreiro_tatico'}
              required
              autoFocus
            />
          </div>

          {tab === 'register' && (
            <div className="auth-field">
              <label htmlFor="auth-email">E-mail</label>
              <input
                id="auth-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
              />
            </div>
          )}

          <div className="auth-field">
            <label htmlFor="auth-password">Senha</label>
            <input
              id="auth-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div className="auth-actions">
            <button type="submit" className="auth-submit-btn" disabled={busy}>
              {busy ? 'Processando…' : tab === 'login' ? 'Entrar no Jogo' : 'Criar Conta e Jogar'}
            </button>
          </div>

          <p className="auth-note muted">
            {tab === 'login'
              ? 'Não possui conta? Clique em "Criar Conta" acima.'
              : 'O primeiro usuário registrado do servidor recebe privilégios administrativos.'}
          </p>
        </form>
      </div>
    </div>
  );
}

